export const SCRAPER_CRONS_FETCHED = 'SCRAPER_CRONS_FETCHED';
export const SCRAPER_CRON_EDIT = 'SCRAPER_CRON_EDIT';
export const SCRAPER_CRON_ADD = 'SCRAPER_CRON_ADD';
export const SCRAPER_CRON_REMOVE = 'SCRAPER_CRON_REMOVE';
